"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const PopupMenu = ({
  children,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_core.Menu, _extends({
  id: "popup-menu",
  keepMounted: true,
  open: true,
  PaperProps: {
    style: {
      maxHeight: 220,
      width: '20ch'
    }
  }
}, props), children);

var _default = PopupMenu;
exports.default = _default;